import restaurantUnitConversionApi from '../../api/restaurant/restaurantUnitConversionApi';
import {
  CustomResponse,
  RestaurantUnitConversionConvertRequest,
  RestaurantUnitConversionConvertResponse,
  RestaurantUnitConversionDTO,
  RestaurantUnitConversionFilter,
  RestaurantUnitConversionFilters,
  RestaurantUnitConversionForm,
  RestaurantUnitConversionPage,
} from '../../types/restaurant/RestaurantUnitConversionTypes';
import { RestaurantPageRequest } from '../../types/restaurant/RestaurantRecipeTypes';
import { restaurantPageQuery } from './restaurantPageQuery';

const payload = (form: RestaurantUnitConversionForm) => ({
  fromUnitId: Number(form.fromUnitId),
  toUnitId: Number(form.toUnitId),
  rawMaterialId: form.rawMaterialId ? Number(form.rawMaterialId) : null,
  factor: Number(form.factor),
  ...(form.id ? { active: form.active } : {}),
});

const RestaurantUnitConversionService = {
  listFiltered: async (
    request: RestaurantPageRequest<RestaurantUnitConversionFilters>
  ) => {
    const query = restaurantPageQuery(request.page, request.size, request.sort);
    const filters = request.filters;
    const response = await restaurantUnitConversionApi.addCustom(
      `/filtered?${query}`,
      {
        search: filters.search?.trim() || null,
        rawMaterialId: filters.rawMaterialId,
        fromUnitId: filters.fromUnitId,
        toUnitId: filters.toUnitId,
        active: filters.active,
      }
    );
    return response.data as RestaurantUnitConversionPage;
  },
  list: async (filter: RestaurantUnitConversionFilter = {}) => {
    const params = new URLSearchParams();

    if (filter.rawMaterialId) {
      params.append('rawMaterialId', String(filter.rawMaterialId));
    }

    params.append('activeOnly', String(filter.activeOnly ?? false));

    const query = params.toString();

    const response = await restaurantUnitConversionApi.fetchCustom(
      query ? `?${query}` : ''
    );

    return response.data as CustomResponse<RestaurantUnitConversionDTO[]>;
  },

  get: async (id: number) => {
    const response = await restaurantUnitConversionApi.fetchById(id);
    return response.data as CustomResponse<RestaurantUnitConversionDTO>;
  },

  create: async (form: RestaurantUnitConversionForm) => {
    const response = await restaurantUnitConversionApi.add(payload(form));
    return response.data as CustomResponse<RestaurantUnitConversionDTO>;
  },

  update: async (id: number, form: RestaurantUnitConversionForm) => {
    const response = await restaurantUnitConversionApi.modify(
      id,
      payload(form)
    );
    return response.data as CustomResponse<RestaurantUnitConversionDTO>;
  },

  updateActive: async (id: number, active: boolean) => {
    const response = await restaurantUnitConversionApi.patchCustom(
      `${id}/active`,
      { active }
    );

    return response.data as CustomResponse<RestaurantUnitConversionDTO>;
  },

  /**
   * Ejecuta una conversión (POST /convert): devuelve la cantidad convertida a
   * la unidad destino, el factor efectivo y la ruta de unidades usada.
   */
  convert: async (body: RestaurantUnitConversionConvertRequest) => {
    const response = await restaurantUnitConversionApi.addCustom('/convert', {
      quantity: body.quantity,
      fromUnitId: body.fromUnitId,
      toUnitId: body.toUnitId,
      rawMaterialId: body.rawMaterialId ?? null,
    });
    return response.data as CustomResponse<RestaurantUnitConversionConvertResponse>;
  },
};

export default RestaurantUnitConversionService;
